import { render, staticRenderFns } from "./VircosData.vue?vue&type=template&id=2a749331&scoped=true&"
import script from "./VircosData.vue?vue&type=script&lang=js&"
export * from "./VircosData.vue?vue&type=script&lang=js&"
import style0 from "./VircosData.vue?vue&type=style&index=0&id=2a749331&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a749331",
  null
  
)

export default component.exports